<template>
  <div class="content">
    <h1>Terms of Use</h1>
    <p><strong>Effective Date:</strong> May 21, 2025</p>
    <p><strong>App Name:</strong> Bantuek</p>
    <p><strong>Contact Email:</strong> chanon.manojit@hotmail.com</p>

    <section>
      <h2>1. Acceptance of Terms</h2>
      <p>
        By downloading or using Bantuek, you agree to be bound by these Terms of Use.
        If you do not agree, please do not use the app.
      </p>
    </section>

    <section>
      <h2>2. Description of Service</h2>
      <p>
        Bantuek is a productivity tool designed to help users track time and activities such as exercising, reading, driving, or any custom activity the user defines.
        Users can view their daily activities in a timeline view, log notes for each activity, and analyze summaries by day, week, month, or year.
      </p>
      <p>
        Additional features include:
      </p>
      <ul>
        <li>Habit tracking</li>
        <li>Reports that summarize activity and habit data over time</li>
      </ul>
      <p>
        Some features (e.g., unlimited creation of habits or activity groups) are available only to subscribed users.
      </p>
    </section>

    <section>
      <h2>3. User Accounts and Authentication</h2>
      <p>
        Bantuek requires users to log in using Firebase Authentication via Apple ID or Google Account only.
        Users are responsible for maintaining the confidentiality of their account and login credentials.
      </p>
    </section>

    <section>
      <h2>4. Subscriptions and Payments</h2>
      <p>
        Bantuek offers subscription-based access through the following plans:
      </p>
      <ul>
        <li><strong>Bantuek Pro (Monthly):</strong> $1.99/month, auto-renewed monthly after free trial</li>
        <li><strong>Bantuek Pro (Yearly):</strong> $9.99/year, auto-renewed yearly after free trial (equivalent to $0.83/month)</li>
      </ul>
      <p>
        Payments are processed through the Apple App Store. All billing, renewals, cancellations, and trial management are handled through your Apple ID account settings.
        We do not directly store or process payment information.
      </p>
      <p>
        You may cancel your subscription at any time via your Apple account. If canceled during the trial, you will not be charged.
      </p>
    </section>

    <section>
      <h2>5. Restrictions</h2>
      <ul>
        <li>Do not use the app for illegal or unauthorized purposes</li>
        <li>Do not reverse engineer, decompile, or tamper with the app's code</li>
        <li>Do not violate intellectual property rights of Bantuek or others</li>
        <li>Do not upload or distribute harmful or offensive content</li>
      </ul>
    </section>

    <section>
      <h2>6. Intellectual Property</h2>
      <p>
        All content, logos, trademarks, and code in Bantuek are the property of the app’s creator unless stated otherwise.
        You may not reproduce or redistribute any part of the app without permission.
      </p>
    </section>

    <section>
      <h2>7. Termination</h2>
      <p>
        We reserve the right to suspend or terminate access to the app at our discretion, including (but not limited to) violations of these Terms or abuse of the service.
      </p>
    </section>

    <section>
      <h2>8. Changes to the Terms</h2>
      <p>
        We may update these Terms of Use at any time.
        Continued use of the app after such changes indicates your acceptance of the new Terms.
      </p>
    </section>

    <section>
      <h2>9. Limitation of Liability</h2>
      <p>
        We do not guarantee the app will be free from bugs or uninterrupted.
        We are not liable for any data loss, system failure, or damages resulting from your use of the app.
      </p>
    </section>

    <section>
      <h2>10. Governing Law</h2>
      <p>
        These Terms are governed by the laws of Thailand, without regard to conflict of law principles.
      </p>
    </section>

    <section>
      <h2>11. Contact</h2>
      <p>
        If you have any questions or concerns regarding these Terms, please contact:<br>
        📧 <a href="mailto:chanon.manojit@hotmail.com">chanon.manojit@hotmail.com</a>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'TermsOfUse',
}
</script>

<style lang="scss" scoped>
.content {
    // padding: 0rem 5rem;
    animation: moveInBottom .5s ease-out .1s;
    animation-fill-mode: backwards;
    .img {
        margin-top: 1rem;
        width: 50%;
    }
    .img-hor {
        display: flex;
        flex-direction: column;
    }
}
</style>